import { PROJECT_WIZARD } from "./projectWizardConstants.js";
import { ESTIMATES } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";

export const projectWizardUpdateEstimate = (data, schedules, project) => {
  return {
    type: PROJECT_WIZARD.UPDATE_ESTIMATE,
    payload: {
      data,
      schedules,
      project
    }
  };
};

// data structure build could be done before the action is called?
export const projectWizardSubmit = (values, id) => {
  return {
    type: PROJECT_WIZARD.POST,
    payload: {
      id,
      ...values
    }
  };
};

export const projectWizardReset = () => {
  return {
    type: PROJECT_WIZARD.RESET
  };
};

// data structure build could be done before the action is called?
export const getProjectEstimate = data => {
  return {
    type: ESTIMATES.POST,
    payload: {
      ...data,
      endpoint: ENDPOINTS.PROJECT_ESTIMATES
    }
  };
};

export const getImagesEstimate = data => {
  return {
    type: ESTIMATES.POST,
    payload: {
      ...data,
      endpoint: ENDPOINTS.IMAGE_ESTIMATES
    }
  };
};

export default {};
